import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Agenda\DeleteEventByIdController::deleteMethod
* @see app/Http/Controllers/Agenda/DeleteEventByIdController.php
* @route '/api/agenda/event/{event}'
*/
export const deleteMethod = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/agenda/event/{event}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Agenda\DeleteEventByIdController::deleteMethod
* @see app/Http/Controllers/Agenda/DeleteEventByIdController.php
* @route '/api/agenda/event/{event}'
*/
deleteMethod.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return deleteMethod.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Agenda\DeleteEventByIdController::deleteMethod
* @see app/Http/Controllers/Agenda/DeleteEventByIdController.php
* @route '/api/agenda/event/{event}'
*/
deleteMethod.delete = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Agenda\DeleteEventByIdController::undo
* @see app/Http/Controllers/Agenda/DeleteEventByIdController.php
* @route '/api/agenda/event/{event}/undo-delete'
*/
export const undo = (args: { event: string | number } | [event: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/agenda/event/{event}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Agenda\DeleteEventByIdController::undo
* @see app/Http/Controllers/Agenda/DeleteEventByIdController.php
* @route '/api/agenda/event/{event}/undo-delete'
*/
undo.url = (args: { event: string | number } | [event: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: args.event,
    }

    return undo.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Agenda\DeleteEventByIdController::undo
* @see app/Http/Controllers/Agenda/DeleteEventByIdController.php
* @route '/api/agenda/event/{event}/undo-delete'
*/
undo.get = (args: { event: string | number } | [event: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Agenda\DeleteEventByIdController::undo
* @see app/Http/Controllers/Agenda/DeleteEventByIdController.php
* @route '/api/agenda/event/{event}/undo-delete'
*/
undo.head = (args: { event: string | number } | [event: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteEventByIdController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteEventByIdController